import moment from 'moment-timezone'
import PropTypes from 'prop-types'

import { Day } from './day'

export const Week = ({
  week,
  showSurroundingMonths,
  onDayClick,
  stylePrimary,
  timezone,
  selectedSpots,
  showSubscript,
  selectedDay,
  availableDays,
  ...props
}) => {
  const belongsToDay = (day, spot) => moment(spot).tz(timezone).format('YYYY-MM-DD') === day
  const hasSelectedSpots = (day) => selectedSpots.some((spot) => belongsToDay(day, spot))

  const selectedSpotsCount = (day) => {
    if (!showSubscript) return null
    if (!hasSelectedSpots(day)) return null

    return selectedSpots.filter((spot) => belongsToDay(day, spot)).length
  }

  const markToday = (day, isToday) => {
    if (isToday && !showSubscript) return true
    if (isToday && !hasSelectedSpots(day)) return true

    return false
  }

  const dayStyle = (day) => {
    if (selectedDay === day) return 'current'
    if (hasSelectedSpots(day)) return 'selected'
    if (availableDays[day] && availableDays[day].length > 0) return 'active'
    return 'disabled'
  }

  return (
    <tr {...props}>
      {week.map(({ id: day, text, isToday, isInCurrentMonth }) => {
        if (!isInCurrentMonth && !showSurroundingMonths) return <td aria-hidden key={day} />

        const today = markToday(day, isToday)

        return (
          <Day
            key={day}
            text={text}
            state={dayStyle(day)}
            disabled={dayStyle(day) === 'disabled'}
            onClick={() => onDayClick(day)}
            today={today}
            subscript={selectedSpotsCount(day)}
            primary={stylePrimary}
            aria-label={moment(day).format('DD MMMM YYYY')}
            aria-current={today ? 'date' : undefined}
          />
        )
      })}
    </tr>
  )
}

Week.propTypes = {
  week: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    text: PropTypes.number.isRequired,
    isToday: PropTypes.bool,
    isInCurrentMonth: PropTypes.bool
  })).isRequired,
  selectedDay: PropTypes.string.isRequired,
  availableDays: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.bool]))).isRequired,
  selectedSpots: PropTypes.arrayOf(PropTypes.string).isRequired,
  showSubscript: PropTypes.bool.isRequired,
  onDayClick: PropTypes.func.isRequired,
  timezone: PropTypes.string.isRequired,
  stylePrimary: PropTypes.bool.isRequired,
  showSurroundingMonths: PropTypes.bool
}
